// Bootstrap JS Components
import "bootstrap/js/dist/collapse";
import "bootstrap/js/dist/offcanvas";
import "bootstrap/js/dist/carousel";
import Tab from "bootstrap/js/dist/tab";

// Stimulus Application
import { Application } from "@hotwired/stimulus";

// Stimulus Controllers
import CarouselController from "./js/controllers/carousel_controller";
import HeroCarouselController from "./js/controllers/hero_carousel_controller";
import WorkSliderController from "./js/controllers/work_slider_controller";
import ShopSliderController from "./js/controllers/shop_slider_controller";
import ShopCardController from "./js/controllers/shop_card_controller";
import ReleasesSliderController from "./js/controllers/releases_slider_controller";
import MoreItemsController from "./js/controllers/more_items_controller";

// Initialize Stimulus
const Stimulus = Application.start();

// Register Controllers
Stimulus.register("carousel", CarouselController);
Stimulus.register("hero-carousel", HeroCarouselController);
Stimulus.register("work-slider", WorkSliderController);
Stimulus.register("shop-slider", ShopSliderController);
Stimulus.register("shop-card", ShopCardController);
Stimulus.register("releases-slider", ReleasesSliderController);
Stimulus.register("more-items", MoreItemsController);

// Navigation scroll effect + hero dark/light swap
document.addEventListener("DOMContentLoaded", () => {
  const nav = document.querySelector(".mpi-nav");
  const hero = document.querySelector(".mpi-hero-slider");

  if (nav) {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        nav.classList.add("scrolled");
      } else {
        nav.classList.remove("scrolled");
      }

      // On pages with a hero: swap nav to dark mode when scrolled past hero
      if (hero) {
        const heroBottom = hero.offsetHeight;
        if (window.scrollY > heroBottom - nav.offsetHeight) {
          document.body.classList.add("mpi-page-light");
        } else {
          document.body.classList.remove("mpi-page-light");
        }
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll(); // Check initial state
  }
});

// Hero carousel is now managed by the hero-carousel Stimulus controller
// See: js/controllers/hero_carousel_controller.js

// Featured tabs auto-rotation (6s cycle, resets on manual interaction)
document.addEventListener("DOMContentLoaded", () => {
  const tabsContainer = document.getElementById("featuredTabs");
  if (!tabsContainer) return;

  const tabButtons = tabsContainer.querySelectorAll('[data-bs-toggle="tab"]');
  if (tabButtons.length < 2) return;

  let currentIndex = 0;
  let autoRotateTimer = null;

  const startAutoRotate = () => {
    if (autoRotateTimer) clearInterval(autoRotateTimer);
    autoRotateTimer = setInterval(() => {
      currentIndex = (currentIndex + 1) % tabButtons.length;
      const tab = Tab.getOrCreateInstance(tabButtons[currentIndex]);
      tab.show();
    }, 6000);
  };

  // Reset timer on manual tab click
  tabButtons.forEach((btn, index) => {
    btn.addEventListener("shown.bs.tab", () => {
      currentIndex = index;
      startAutoRotate();
    });
  });

  startAutoRotate();
});
